import React,{useState,useEffect} from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import navData from '../data/navData'
import logo from '../images/cuet-img/cuetlogo.png'
import admnsBuilding from '../images/cuet-img/admns-blding.jpg'
import graduate from '../images/cuet-img/a graduate.jpg'
import audi from '../images/cuet-img/audi.jpg'
import vcBuilding from '../images/cuet-img/vc building.jpg'
import SearchBar from './SearchBar'
import Logo from './Logo'

const Navbar = () => {
    const [height,setHeight] = useState(false)
    const [menuOpen, setMenuOpen] = useState(false)
    const [dropdown, setDropdown] = useState(false)
    const [megaDropdown, setMegaDropdown] = useState(false)

    const toggler = (e) => {
        e.preventDefault()
        setMenuOpen(!menuOpen)
    }

    const handleDropdown = (e) => {
        e.preventDefault()
        setDropdown(!dropdown)
    }

    const handleMegaDropdown = (e) => {
        e.preventDefault()
        setMegaDropdown(!megaDropdown)
    }

    const checkHeight = () =>{
        console.log(window.pageYOffset);
        if(window.pageYOffset > 210){
            setHeight(true)
        }
        else{
            setHeight(false)
        }
    }
    useEffect(() => {
        checkHeight()
        window.addEventListener('scroll',checkHeight)
    }, [])

    return (
        <Wrapper>

            <section className="top p-1 my-auto bg-dark text-light">
                <div className="">
                    <div className="row">
                        <div className="col-lg-1"></div>
                        <div className="notice col-lg-6 d-flex justify-content-center">
                            {/* <Link to='/notice' className='text-dark fw-bolder d-flex my-auto text-uppercase'> Notice </Link>  */}
                            <marquee width="" direction="left" height="">
                                Combined Admission Test of CUET, KUET & RUET will be held on 13th Nov, 2021 <span><Link to='/notice'>see more...</Link></span>
                            </marquee>
                        </div>
                        {/* <div className="col-lg-2">
                            <Link className='text-light' to='/login'>Login</Link> | <Link to='/register' className='text-primary'>Registration</Link>
                        </div> */}
                        <div className="col-lg-3">
                            <SearchBar />

                        </div>
                        <div className="col-lg-2">
                            <Link to='/login' className='text-light fw-bold'>LOGIN</Link> | <Link to='/faq' className='text-light fw-bold'>FAQ</Link>
                        </div>
                    </div>


                </div>
            </section>

            <section className="branding bg-light text-dark p-2">
                <div className="container">
                    <div className="row mt-lg-4">
                        <div className="col-lg-3 m-auto text-center text-lg-start">
                            <Logo/>
                        </div>
                        <div className="col-lg-3 d-flex">
                            <i className="fas fa-phone my-auto"></i>
                            <div className='my-auto px-4'>
                                <strong>call support</strong>
                                <p>+880-31-714946</p>
                            </div>
                        </div>

                        <div className="col-lg-3 d-flex">
                            <i className="fas fa-envelope my-auto"></i>
                            <div className='my-auto px-4'>
                                <strong>Email support</strong>
                                <p>iict@cuet.ac.bd, registrar@cuet.ac.bd</p>
                            </div>
                        </div>
                        <div className="col-lg-3 d-flex">
                            <i className="fas fa-map my-auto"></i>
                            <div className='my-auto px-4'>
                                <strong>location</strong>
                                <p>Pahartoli, Raozan-4349,Chittagong, Bangladesh</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <nav className={height ? 'sticky':''}>

                <div className={menuOpen ? `menu-btn open` : `menu-btn`} onClick={toggler}>
                    <div className="menu-btn_burger"></div>
                </div>

                <ul className={menuOpen ? `menu-items open my-auto` : `menu-items my-auto`}>

                    <li>
                        <a href="" className={megaDropdown ? `menu-item expand-btn open` : `menu-item expand-btn`} onClick={handleMegaDropdown}>Academics</a>
                        <div className="mega-menu expandable">
                            <div className="content bg-light">

                                <div className="col">
                                    <section>
                                        <Link to='/academics-home'><h4><i className="fas fa-home"></i><span>academics home</span></h4></Link>
                                        <Link to='/employment'><h4><i className="fas fa-university"></i><span>employment opportunities</span></h4></Link>
                                        <Link to="/*" className="img-wrapper">
                                            <img src={admnsBuilding} className='img-fluid' alt="Random Image" />
                                        </Link>
                                        <Link to='/admissions'><h4 className='text-center'>apply for admissions <i className="fas fa-caret-right"></i></h4></Link>
                                    </section>
                                </div>
                                <div className="col">
                                    <section>
                                        <h2>colleges</h2>
                                        <ul className='mega-links'>
                                            <li class="cu-nav-item"><Link to="/*">College of Engineering, Computing and Applied Sciences</Link></li>
                                            <li class="cu-nav-item"><Link to="/*">College of Science</Link></li>
                                            <li class="cu-nav-item"><Link to="/*">Graduate School</Link></li>
                                        </ul>
                                    </section>
                                </div>
                                <div className="col">
                                    <section>
                                        <h2>academic resources</h2>
                                        <ul className='mega-links'>
                                            <li class="cu-nav-item"><Link to='/*' >Academic Calendar</Link></li>
                                            <li class="cu-nav-item"><Link to='/*'>Registrar</Link></li>
                                            <li class="cu-nav-item"><Link to='/*' >Division of Undergraduate Studies</Link></li>
                                            <li class="cu-nav-item"><Link to='/*' >Center for Career and Professional Development</Link></li>

                                            <li class="cu-nav-item"><Link to='/*'>Libraries</Link></li>
                                        </ul>
                                    </section>
                                </div>
                                <div className="col">
                                    <section>
                                        <h2>outside the classroom</h2>
                                        <ul className='mega-links'>
                                            <li class="cu-nav-item"><Link to='/*' >Creative Inquiry and Undergraduate Research</Link></li>
                                            <li class="cu-nav-item"><Link to='/*'>Cooperative Education</Link></li>
                                            <li class="cu-nav-item"><Link to='/*'>University Professional Internship and Co-op Program (UPIC)</Link></li>
                                            <li class="cu-nav-item"><Link to='/*'>Study Abroad</Link></li>
                                        </ul>
                                    </section>
                                </div>
                            </div>
                        </div>

                    </li>

                    <li>
                        <a href="" className={megaDropdown ? `menu-item expand-btn open` : `menu-item expand-btn`} onClick={handleMegaDropdown}>Admissions</a>
                        <div className="mega-menu expandable">
                            <div className="content bg-light">

                                <div className="col">
                                    <section>
                                        <Link to='/admission-home'><h4><i className="fas fa-home"></i> <span>admissions home</span></h4></Link>
                                        <Link to='/tour-schedule'><h4><i className="fas fa-calendar-alt"></i> <span>schedule a tour</span></h4></Link>
                                        <Link to="/*" className="img-wrapper">
                                            <img src={audi} alt="Random Image" />
                                        </Link>
                                        <Link to='/admissions'><h4 className='text-center'>apply for admissions <i className="fas fa-caret-right"></i></h4></Link>
                                    </section>
                                </div>
                                <div className="col">
                                    <section>
                                        <h2>apply to cuet</h2>
                                        <ul className='mega-links'>
                                            <li class="cu-nav-item"><Link to='/*' >First-Year Undergraduate</Link></li>
                                            <li class="cu-nav-item"><Link to='/*' >Transfer Undergraduate</Link></li>
                                            <li class="cu-nav-item"><Link to='/*' >International Undergraduate</Link></li>
                                            <li class="cu-nav-item"><Link to='/*'>Graduate Students</Link></li>
                                        </ul>
                                    </section>
                                </div>
                                <div className="col">
                                    <section>
                                        <h2>academic opportunities</h2>
                                        <ul className='mega-links'>
                                            <li class="cu-nav-item"><Link to='/*' >Majors</Link></li>
                                            <li class="cu-nav-item"><Link to='/*' >Graduate Programs</Link></li>
                                            <li class="cu-nav-item"><Link to='/*' >Online Graduate Programs</Link></li>
                                            <li class="cu-nav-item"><Link to='/*' >Scholar Programs</Link></li>
                                            <li class="cu-nav-item"><Link to='/*'>Paths to Graduate School</Link></li>

                                        </ul>
                                    </section>
                                </div>
                                <div className="col">
                                    <section>
                                        <h2>financial aid</h2>
                                        <ul className='mega-links'>
                                            <li class="cu-nav-item"><Link to='/*' >Tuition and Fee Calculator</Link></li>
                                            <li class="cu-nav-item"><Link to='/*'>Undergraduate Financial Aid</Link></li>
                                            <li class="cu-nav-item"><Link to='/*'>Graduate Fellowships and Awards</Link></li>
                                            <li class="cu-nav-item"><Link to='/*'>Residency Requirements</Link></li>
                                        </ul>
                                    </section>
                                </div>
                            </div>
                        </div>

                    </li>

                    <li>
                        <a href="" className={megaDropdown ? `menu-item expand-btn open` : `menu-item expand-btn`} onClick={handleMegaDropdown}>Campus Life</a>
                        <div className="mega-menu expandable">
                            <div className="content bg-light">

                                <div className="col">
                                    <section>
                                        <Link to='/campus-life'><h4><i className="fas fa-home"></i><span>campus life home</span></h4></Link>
                                        <Link to='/sports-club'><h4><i className="fas fa-running"></i><span>club sports</span></h4></Link>
                                        <Link to="/*" className="img-wrapper">
                                            <img src={graduate} alt="Random Image" />
                                        </Link>
                                        <Link to='/books-center'><h4 className='text-center'>books center for the performing arts <i className="fas fa-caret-right"></i></h4></Link>
                                    </section>
                                </div>
                                <div className="col">
                                    <section>
                                        <h2>join your cuet family</h2>
                                        <ul className='mega-links'>
                                            <li class="cu-nav-item"><Link to='/*' >Finding Your Community</Link></li>
                                            <li class="cu-nav-item"><Link to='/*' >Living-Learning Communities</Link></li>
                                            <li class="cu-nav-item"><Link to='/*'>Student Veterans</Link></li>
                                            <li class="cu-nav-item"><Link to='/*'>Multicultural Programs</Link></li>
                                        </ul>
                                    </section>
                                </div>
                                <div className="col">
                                    <section>
                                        <h2>service on campus</h2>
                                        <ul className='mega-links'>
                                            <li class="cu-nav-item"><Link to='/*' >Housing &amp; Dining</Link></li>
                                            <li class="cu-nav-item"><Link to='/*'>Campus Recreation</Link></li>
                                            <li class="cu-nav-item"><Link to='/*'>Parking and Transportation</Link></li>
                                            <li class="cu-nav-item"><Link to='/*' >Student Health Services</Link></li>
                                            <li class="cu-nav-item"><Link to='/*'>TigerOne Card Services</Link></li>
                                            <li class="cu-nav-item"><Link to='/*'>Clemson Athletics</Link></li>
                                        </ul>
                                    </section>
                                </div>
                                <div className="col">
                                    <section>
                                        <h2>get involved</h2>
                                        <ul className='mega-links'>
                                            <li class="cu-nav-item"><Link to='/*'>Clubs and Organizations</Link></li>
                                            <li class="cu-nav-item"><Link to='/*'>Fraternity and Sorority Life</Link></li>
                                            <li class="cu-nav-item"><Link to='/*'>Orientation Ambassadors</Link></li>
                                            <li class="cu-nav-item"><Link to='/*' >Tiger Media</Link></li>
                                            <li class="cu-nav-item"><Link to='/*'>Graduate Student Government</Link></li>
                                            <li class="cu-nav-item"><Link to='/*'>Undergraduate Student Government</Link></li>
                                        </ul>
                                    </section>
                                </div>
                            </div>
                        </div>

                    </li>

                    <li>
                        <a href="" className={megaDropdown ? `menu-item expand-btn open` : `menu-item expand-btn`} onClick={handleMegaDropdown}>Research</a>
                        <div className="mega-menu expandable">
                            <div className="content bg-light">

                                <div className="col">
                                    <section>
                                        <Link to='/research-home'><h4><i className="fas fa-home"></i><span>research home</span></h4></Link>
                                        <Link to='/crf'><h4><i className="fas fa-chart-bar"></i><span>cuet research foundation</span></h4></Link>
                                        <Link to="/*" className="img-wrapper">
                                            <span className="img"><img src={logo} alt="Random Image" />
                                            </span
                                            ></Link>
                                        <Link to='/research-division'><h4 className='text-center'>division of research <i className="fas fa-caret-right"></i></h4></Link>
                                    </section>
                                </div>
                                <div className="col">
                                    <section>
                                        <h2>research opportunities</h2>
                                        <ul className='mega-links'>
                                            <li class="cu-nav-item"><Link to='/*'>Student Research at CUET</Link></li>
                                            <li class="cu-nav-item"><Link to='/*'>Research Facilities</Link></li>
                                            <li class="cu-nav-item"><Link to='/*'>Serving Bangladesh Through Research</Link></li>
                                            <li class="cu-nav-item"><Link to='/*'>School of Health Research</Link></li>
                                        </ul>
                                    </section>
                                </div>
                                <div className="col">
                                    <section>
                                        <h2>innovation and economic development</h2>
                                        <ul className='mega-links'>

                                            <li class="cu-nav-item"><Link to='/*'>CUET Biomedical Engineering Innovation Campus (CUBEInC)</Link></li>
                                            <li class="cu-nav-item"><Link to='/*'>Center for Human Genetics</Link></li>
                                            <li class="cu-nav-item"><Link to='/*'>Innovation Campus and Technology Park</Link></li>
                                        </ul>
                                    </section>
                                </div>

                            </div>
                        </div>

                    </li>

                    <li>
                        <a href="" className={megaDropdown ? `menu-item expand-btn open` : `menu-item expand-btn`} onClick={handleMegaDropdown}>about cuet</a>
                        <div className="mega-menu expandable">
                            <div className="content bg-light">

                                <div className="col">
                                    <section>
                                        <Link to='/about-cuet-home'><h4><i className="fas fa-home"></i><span>about cuet</span></h4></Link>
                                        <Link to='/cuet-news'><h4><i className="fas fa-newspaper"></i><span>cuet news</span></h4></Link>
                                        <a href="#" className="img-wrapper">
                                            <img src={vcBuilding} className='img-fluid' alt="Random Image" />
                                        </a>
                                        <Link to='/cuet-at-a-glance'><h4 className='text-center'>cuet at a glance <i className="fas fa-caret-right"></i></h4></Link>
                                    </section>
                                </div>
                                <div className="col">
                                    <section>
                                        <h2>for birds and animals</h2>
                                        <ul className='mega-links'>
                                            <li><Link to='/*' >Traditions</Link></li>
                                            <li><Link to='/*'>Birds Heritage</Link></li>
                                            <li><Link to='/*'>Things To Do in CUET</Link></li>
                                            <li><Link to='/*'>Visit CUET</Link></li>
                                        </ul>
                                    </section>
                                </div>
                                <div className="col">
                                    <section>
                                        <h2>campus resources</h2>
                                        <ul className='mega-links'>
                                            <li><Link to='/*'>Employment Opportunities</Link></li>
                                            <li><Link to='/*'>Home and Garden Information Center</Link></li>
                                            <li><Link to='/*'>Brand Guidelines</Link></li>
                                            <li><Link to='/*'>Academic Calendar</Link></li>
                                            <li><Link to='/*'>Training</Link></li>
                                        </ul>
                                    </section>
                                </div>
                                <div className="col">
                                    <section>
                                        <h2>campus leadership</h2>
                                        <ul className='mega-links'>
                                            <li><Link to='/*'>Board of Trustees</Link></li>
                                            <li><Link to='/*'>President</Link></li>
                                            <li><Link to='/*'>Academic Affairs and Provost</Link></li>
                                            <li><Link to='/*'>Student Affairs</Link></li>
                                            <li><Link to='/*'>Faculty Senate</Link></li>
                                        </ul>
                                    </section>
                                </div>
                            </div>
                        </div>

                    </li>


                    {/* dropdown */}
                    <li className='dropdown'>
                        <a href="#" className={dropdown ? `menu-item expand-btn open` : `menu-item expand-btn`} onClick={handleDropdown}>Students</a>
                        <ul className='dropdown-menu-items expandable bg-light'>
                            <li><Link to="/*"> Faculty & Stuffs</Link></li>
                            <li><Link to="/*"> Parents</Link></li>
                            <li><Link to="/*"> alumni</Link></li>
                        </ul>
                    </li>
                </ul>

            </nav>



        </Wrapper >
    )
}

const Wrapper = styled.section`
 
    .branding{
        
        i{
            font-size: 20px;
            padding:5px;
            border: 2px solid #000;
            color: #000;
            border-radius: 50%;
            height: 35px;
            width: 35px;
            text-align: center;
            transition: var(--transition);
         
        }
        strong{
            text-transform: uppercase;
        }


    }

    @media screen and (min-width:992px){
        .branding{
            /* position: absolute; */
            margin-top: -40px;
            clip-path: polygon(23% 0, 25% 25%, 100% 25%, 100% 100%, 0 100%, 0 0);        
        
        }
    }


nav{
    position: relative;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px;
    z-index:1;
    transition: var(--transition);
    background-color: var(--clr-grey-1);
}
nav.sticky{
    position: fixed;
    top: 0;
    transition: var(--transition);
    border-bottom: 2px solid;
    box-shadow: 3px 3px 5px 3px var(--clr-grey-1);
}


/* start hamburger */
.menu-btn{
        position: relative;
        display: none;
        justify-content:center;
        align-items: center;
        width: 80px;
        height: 80px;
        cursor: pointer;
        transition: all 0.5s ease-in-out;
        /* border: 3px solid #fff; */
        z-index:2;
        
    }

    .menu-btn_burger{
        width: 40px;
        height: 3px;
        background: var(--clr-primary-3);
        border-radius: 5px;
        box-shadow:0 2px 5px var(--clr-primary-2);
        transition: all 0.5s ease-in-out;
    }


    .menu-btn_burger::before,
    .menu-btn_burger::after{
        content: '';
        position: absolute;
        width: 40px;
        height: 3px;
        background: var(--clr-primary-3);
        border-radius: 5px;
        box-shadow:0 2px 5px var(--clr-primary-2);
        transition: all 0.5s ease-in-out;
    }

    .menu-btn_burger::before{
        transform: translateY(-0.7rem);
    
    }
    .menu-btn_burger::after{
        transform: translateY(0.7rem);
    }

    /* animate */

    .menu-btn.open .menu-btn_burger{
        /* transform: translateX(1.5rem); */
        /* background: transparent; */
        /* transform: rotate(360deg); */
        box-shadow:0 2px 5px var(--clr-primary-2);
    }

    .menu-btn.open .menu-btn_burger::before{
        transform: translate(-.5rem,.7rem);
    }

    .menu-btn.open .menu-btn_burger::after{
        transform: translate(-.5rem,-.7rem);
    }

/*--- end hamburger ----*/

.menu-items{
    display: flex;
    align-items: center;

        li{
        padding: 0.5rem 1rem;
        transition: background var(--transition);
        border-right: 1px solid var(--clr-grey-7);

        &:last-child{
            border-right: none;
        }
        a{
            display: block;
            color: var(--clr-white);
            font-size: 18px;
            text-transform: uppercase;
        }
        &:hover a{
                color: var(--clr-grey-7);
        }

   
    }
}


/*start mega menu */
.mega-menu{
    align-items: center;
    position: absolute;
    left: 0;
    top: 200px;
    width: 100%;
    opacity: 0;
    visibility: hidden;
    transition: var(--transition);
    

    .content{
        box-shadow:var(--dark-shadow);
        padding: 1rem;
        width: 100%;
        justify-content: space-between;
        display: grid;
        grid-template-columns: repeat(4,1fr);
        gap: 1rem;
        text-transform:capitalize;

        .col{
            display: flex;
            flex-direction:column;
            justify-content: space-between;
            line-height: 1.5rem;
            text-transform:capitalize;
            a{
                transition: var(--transition);
                color: var(--clr-black);
                font-weight: normal;
                cursor: pointer;
                &:hover{
                    color: var(--clr-grey-7);
                }
            }
            section{
                i{
                    font-size: 18px;
                    padding:5px;
                    margin: 2px 5px;
                    border: 2px solid var(--clr-black);
                    color: var(--clr-black);
                    border-radius: 50%;
                    height: 30px;
                    width: 30px;
                    text-align: center;
                    
                }
                span{
                    border-bottom: 1px solid var(--clr-grey-7);
                    font-size: 1rem;
                }
                h4{
                    font-size: 20px;
                }
            } 

            .img-wrapper{
                display: block;
                position: relative;
                width: 100%;
                height: 20vw;
                overflow: hidden;
                box-shadow:var(--dark-shadow);
                margin-bottom:10px;
                &:hover img{
                    transform: scale(1.1);
                }
            }
            img{
                position: absolute;
                left: 17%;
                top: 3%;
                width: 200px;
                height:200px;
                align-items: center;
                transition: transform 0.5s ease-in-out;
            }
            h2{
                display: block;
                color: var(--clr-black);
                line-height: 2rem;
                padding: 0 5px;
                font-weight: 700;
            }
        }
    }
}


.mega-links{
    padding-left: 0;
}

.mega-links li {
  padding: 0.5rem;
  border-right: none;
}

.mega-links li a{
    text-transform: capitalize;
    color: var(--clr-white);
}
.menu-items li:hover .mega-menu{
    opacity: 1;
    visibility: visible;
    top: 50px;
}

/*end mega menu */


/* dropdown */
.dropdown{
    position: relative;
}

.dropdown-menu-items{
    position: absolute;
    width: 100%;
    top: 80px;
    left: 0;
    opacity: 0;
    visibility: hidden;
    transition: all 0.5s ease;
    padding-left: 0;
    transition: var(--transition);
    box-shadow:var(--shadow);
    
}

.dropdown-menu-items li{
    border: none;
    border-bottom: 1px solid var(--clr-grey-7);
    &:last-child{
        border-bottom: none;
    }
    a{
        white-space: wrap !important;
        text-transform: capitalize  !important;
        color: var(--clr-black) !important;
    }
}

.dropdown:hover .dropdown-menu-items{
    opacity: 1;
    visibility: visible;
    top: 50px;
    right: 0;
}


@media (max-width:767px){
    .title h1{
        display: none;
    }
    .title h2{
        padding: 0.5rem 0.5rem;
        font-size: 10px;
        text-align: center;
        padding: 0 16px;
    }
   .header .logo img{
        height: 60px !important;
        width: 60px !important;
    }
    
    .menu-items li {
        font-size: 0.8rem !important;
        font-weight: 800;
        line-height: 1rem;
    }
    
    .menu-items li a {
        font-size: 0.8rem !important;
        font-weight: 800;
    }
 
}
    
@media (min-width:768px) and (max-width:991px){
 .title h1{
     font-size: 1.8rem !important;
 }
 .title h2{
     font-size: 0.8rem;
 }
 .menu-items li{
     padding: 0.3rem 0.3rem;
 }
 
 .menu-items li a{
     font-size: 0.8rem ;
     font-weight: 600 !important;
 }


}


@media screen and (max-width:991px){
    /* hamburger */
        .menu-btn{
            display: flex;
        }
    /* end hamburger */

        .header .menu-items{
            position: absolute;
            opacity: 0;
            /* height: calc(100vh - 100%); */
            height: 100vh;
            width: 100%;
            max-width: 450px;
            top: 100%;
            right: 0;
            display: block;
            padding: 0.5rem;
            line-height: 1.5rem;
            overflow-y: auto;
            transition: all 0.5s ease-out;
            z-index:-1;
            transform: translateX(100vh);
            background: var(--clr-primary-3);
        }

        .title h1{
            font-size: 0.9rem;
        }
        .menu-items.open{
            opacity: 1;
            transform: translateY(0);
        
        }
        .menu-items li{
            margin: 15px 10px;
            border-left:none;
        }
    
        .menu-items li a{
            padding: 0 1rem;
            display: block;
            font-size: 1.4rem;
        }

        .menu-items li:hover{
            background: transparent;
        }

        /* dropdown mega menus */

        .menu-items .dropdown-menu-items,
        .menu-items .mega-menu{
            position: static;
            opacity: 1;
            top: 4rem;
            visibility: visible;
            /* padding-left: 1rem; */
            width: 100%;
            max-height: 0;
            transform: scaleY(0);
            transform-origin:top;
            overflow: hidden;
            transition: all 0.5s ease;
        }

        .expand-btn.open + .expandable{
            max-height: 100%;
            transform: scaleY(1);
        }

        .expandable li{
            margin: 0;
        }

        .expandable li a{
            font-size: 1rem;
        }

        .mega-menu .content{
            grid-template-columns: auto;
            padding: 1rem 1rem 0 1rem;
        }
    
        .mega-menu .content .col{
            width: 100%;
            padding-top:1rem;
            margin-bottom: 0.5rem;
            border-top: 1px solid #1a3246;
        }
    
        .mega-menu .content .col:first-child{
            border-top: none;
        }
    
        .content .col .mega-links {
            border-left: 0px;
            padding-left: 1rem;
        }

        .col .mega-links li {
            margin: 0;
        }
    
    
    }





`
export default Navbar
